export function ellipsisFilter() {
    return (val: string, size: number): string => {
        if (size && val.length > size) {
            return val.substring(0, size - 3) + "...";
        }

        return val;
    };
}
